import {ApplicationMenuItemDef} from '../main/routing/application-menu-item-def';
import {ContactMenuData} from './contact-menu-data';

export const ContactMenu: ApplicationMenuItemDef[] = [
  {data: ContactMenuData.allLlist},
  {data: ContactMenuData.customerList},
  {data: ContactMenuData.new},
];
